import {isFeatureEnabled} from '@github-ui/feature-flags'
import NewFeaturesCopilotPlansIndex from './NewIndex'
import LegacyFeaturesCopilotPlansIndex from './LegacyIndex'

export default function FeaturesCopilotIndex() {
  if (isFeatureEnabled('site_copilot_free')) return <NewFeaturesCopilotPlansIndex />
  return <LegacyFeaturesCopilotPlansIndex />
}

try{ FeaturesCopilotIndex.displayName ||= 'FeaturesCopilotIndex' } catch {}